class TransactionCompany {
    name;
    companyId;
    type;
    constructor(response) {
        if (response !== undefined) {
            this.name = response.name;
            this.companyId = response.companyId;
            this.type = response.type;
        }
    }
}
export default TransactionCompany;
